"use client";

import { Vehicle, VehicleStatusType } from "@alba-cars/common-modules";
import { useTranslations } from "next-intl";
import React, { useState } from "react";

import TestDriveModal from "./TestDriveModal";
import Button from "@/components/ui/buttons/Button";
import { isReservedConsignment } from "@/lib/vehicle-ownership";

interface TestDriveButtonProps {
  car: Vehicle;
  className?: string;
  disabled?: boolean;
}

const TestDriveButton = ({ car, className, disabled = false }: TestDriveButtonProps) => {
  const t = useTranslations("CarDetails.testDrive");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isSold = car.status === VehicleStatusType.SOLD;
  const isCarOfTheDay = isReservedConsignment(car);
  const buttonDisabled = disabled || isSold || isCarOfTheDay;

  const buttonText = isSold ? t("vehicleSold") : t("bookTestDrive");

  return (
    <>
      <Button
        buttonText={buttonText}
        bgColor="primary"
        textColor="white"
        disabled={buttonDisabled}
        className={
          className
            ? className
            : "my-2 w-full py-4 text-center text-white transition-all duration-300 ease-in-out hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-50"
        }
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          if (buttonDisabled) {
            return;
          }

          setIsModalOpen(true);
        }}
      />

      <TestDriveModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} vehicleId={car.id} />
    </>
  );
};

export default TestDriveButton;
